import React, { useState, useEffect } from 'react';
import { getIndianMovies } from '../services/tmdbService';
import SectionHeader from './SectionHeader';
import MediaGridCard from './MediaGridCard';
import Pagination from './Pagination';
import LoadingSpinner from './LoadingSpinner';
import '../styles/main.css';

const Indian = () => {
  const [indianMovies, setIndianMovies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchIndianMovies = async () => {
      setLoading(true);

      try {
        const movies = await getIndianMovies(currentPage);

        // Urutkan film dari tanggal rilis terbaru ke terlama
        const sortedMovies = (movies || []).sort((a, b) => {
          const dateA = new Date(a.release_date || '1900-01-01');
          const dateB = new Date(b.release_date || '1900-01-01');

          return dateB - dateA;
        });

        setIndianMovies(sortedMovies);
      } catch (error) {
        console.error('Error fetching Indian movies:', error);
        setIndianMovies([]);
      } finally {
        setLoading(false);
      }
    };

    fetchIndianMovies();
  }, [currentPage]);

  const handlePageChange = (direction) => {
    setCurrentPage((prevPage) => {
      if (direction === 'next') {
        return prevPage + 1;
      }

      if (direction === 'prev') {
        return Math.max(prevPage - 1, 1);
      }

      return prevPage;
    });
  };

  return (
    <section className="content-section" id="indian">
      <SectionHeader
        title="Indian Movies"
        icon="fi fi-in"
      />

      {loading ? (
        <LoadingSpinner label="Loading Indian movies" />
      ) : indianMovies.length > 0 ? (
        <div className="media-grid">
          {indianMovies.slice(0, 20).map((movie) => (
            <MediaGridCard
              key={movie.id}
              item={movie}
              linkTo={`/movie/${movie.id}`}
              icon="fa-star"
            />
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p>No Indian movies found.</p>
        </div>
      )}

      <Pagination
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </section>
  );
};

export default Indian;